var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 130.00 130.00",
    enableBackground: "new 0 0 130 120",
    xmlSpace: "preserve",
    width: "800px",
    height: "800px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Infos"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "BG",
    x: -200,
    y: -1350,
    fill: "#FFFFFF",
    width: 2180,
    height: 1700
  })), /*#__PURE__*/React.createElement("g", {
    id: "Others"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    fill: "#DC4437",
    width: 130,
    height: 13.3
  }), /*#__PURE__*/React.createElement("rect", {
    y: 26.7,
    fill: "#DC4437",
    width: 130,
    height: 13.3
  }), /*#__PURE__*/React.createElement("rect", {
    y: 80,
    fill: "#DC4437",
    width: 130,
    height: 13.3
  }), /*#__PURE__*/React.createElement("rect", {
    y: 106.7,
    fill: "#DC4437",
    width: 130,
    height: 13.3
  }), /*#__PURE__*/React.createElement("rect", {
    y: 53.3,
    fill: "#DC4437",
    width: 130,
    height: 13.3
  }), /*#__PURE__*/React.createElement("rect", {
    y: 13.3,
    fill: "#FFFFFF",
    width: 130,
    height: 13.3
  }), /*#__PURE__*/React.createElement("rect", {
    y: 40,
    fill: "#FFFFFF",
    width: 130,
    height: 13.3
  }), /*#__PURE__*/React.createElement("rect", {
    y: 93.3,
    fill: "#FFFFFF",
    width: 130,
    height: 13.3
  }), /*#__PURE__*/React.createElement("rect", {
    y: 66.7,
    fill: "#FFFFFF",
    width: 130,
    height: 13.3
  }), /*#__PURE__*/React.createElement("rect", {
    y: 0,
    fill: "#2A66B7",
    width: 70,
    height: 66.7
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "13.5,4 15.8,8.9 21,9.7 17.2,13.6 18.1,19 13.5,16.4 8.9,19 9.8,13.6 6,9.7 11.2,8.9 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "34,4 36.3,8.9 41.5,9.7 37.8,13.6 38.6,19 34,16.4 29.4,19 30.2,13.6 26.5,9.7 31.7,8.9 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "54.5,4 56.8,8.9 62,9.7 58.2,13.6 59.1,19 54.5,16.4 49.9,19 50.8,13.6 47,9.7 52.2,8.9 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "24,24 26.3,28.9 31.5,29.7 27.8,33.6 28.6,39 24,36.4 19.4,39 20.2,33.6 16.5,29.7 21.7,28.9 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "44.5,24 46.8,28.9 52,29.7 48.2,33.6 49.1,39 44.5,36.4 39.9,39 40.8,33.6 37,29.7 42.2,28.9 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "13.5,45.2 15.8,50.1 21,50.9 17.2,54.7 18.1,60.2 13.5,57.6 8.9,60.2 9.8,54.7 6,50.9 11.2,50.1 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "34,45.2 36.3,50.1 41.5,50.9 37.8,54.7 38.6,60.2 34,57.6 29.4,60.2 30.2,54.7 26.5,50.9 31.7,50.1 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "54.5,45.2 56.8,50.1 62,50.9 58.2,54.7 59.1,60.2 54.5,57.6 49.9,60.2 50.8,54.7 47,50.9 52.2,50.1 "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Europe"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Row_5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Row_4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Row_3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Row_2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Row_1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsd);
export default __webpack_public_path__ + "static/media/USD.8027fec1226257c30a723b5158a63df8.svg";
export { ForwardRef as ReactComponent };